module.exports = __webpack_public_path__ + "static/img/bg3.06de315.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/seo/bg3.png
// module id = lMQ2
// module chunks = 69